@if (device) {
  <app-device-form
    [device]="device"
    action="{{ 'edit' | translate }}"
    (close)="closeForm()">
  </app-device-form>
}
